import React, { useState, useEffect, useMemo } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useTheme } from '../context/ThemeContext';
import { useInboxNotifications } from '../hooks/useInboxNotifications';
import InstallPWAPrompt from './InstallPWAPrompt';
import { AgentBubble } from './AgentBubble';
import CrustSubNav from './CrustSubNav';
import {
  LayoutDashboard, Map, Store, ClipboardCheck, Lightbulb, GraduationCap, Bell, LogOut, Menu,
  Cookie, User, ChevronRight, ChevronLeft, FileText, Star, Users, Building2, History, ScanLine,
  BookOpen, BarChart3, Wallet, Trophy, Brain, Target, Zap, MessageCircle, Tag, Calculator, Tv,
  ShoppingCart, Library, ChefHat, Truck, CalendarDays, Clock, ShieldCheck, Crown, Tablet,
  MessageSquareText, TrendingUp, Settings, Gem, Video, ClipboardList, Sparkles, Edit3 as Edit, Coins,
  Sun, Moon, Search, ChevronDown, Megaphone, Activity, ShoppingBag, Database,
} from 'lucide-react';
import { Package } from 'lucide-react';
import { LayoutGrid } from 'lucide-react';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { Sheet, SheetContent, SheetTrigger } from './ui/sheet';
import { NotificationBell } from './NotificationCenter';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import api from '../lib/api';

// ============== NAV STRUCTURE (12 modules) ==============
export const navSections = [
  {
    title: '🧠 BOUFI AI',
    items: [
      { path: '/attention', label: '✨ Mon Attention', icon: Sparkles, public: true, moduleId: 'attention' },
      { path: '/operations', label: 'Opérations', icon: Sparkles, public: true, moduleId: 'operations' },
      { path: '/pilotage-alize', label: '🎯 Pilotage Alizé', icon: Target, permission: 'pilotage_alize', moduleId: 'pilotage_alize' },
      { path: '/ma-journee', label: '📍 Aujourd\'hui', icon: Sparkles, permission: 'reseau', moduleId: 'reseau' },
      { path: '/missions', label: '✅ Missions', icon: Target, permission: 'reseau', moduleId: 'reseau' },
      { path: '/agenda', label: '📅 Agenda', icon: CalendarDays, permission: 'reseau', moduleId: 'reseau' },
      { path: '/pilotage-boutique', label: '🎛 Pilotage Boutique', icon: Store, permission: 'reseau', moduleId: 'reseau' },
      { path: '/reseau', label: 'Mon Réseau', icon: Store, permission: 'reseau', moduleId: 'reseau' },
      { path: '/reseau/doctrine', label: 'Coach Boufi', icon: Target, permission: 'reseau', moduleId: 'reseau' },
      { path: '/boutique-os', label: '🖥 Boutique OS', icon: Store, permission: 'reseau', moduleId: 'reseau' },
      { path: '/boutique-os', label: '🖥 Boutique OS', icon: Store, permission: 'reseau', moduleId: 'reseau' },
      { path: '/coach', label: 'Écran Boutique', icon: Store, permission: 'reseau', moduleId: 'reseau' },
      { path: '/menu-board', label: 'Menu Board TV', icon: Tv, permission: 'reseau', moduleId: 'reseau' },
      { path: '/boufi-ai', label: 'Corner Copilot', icon: Brain, permission: 'corner_view', moduleId: 'corner_copilot' },
      { path: '/boufi-network', label: 'BOUFI Network', icon: Store, permission: 'boufi_network', moduleId: 'corner_copilot' },
      { path: '/deploiement', label: 'Référentiel Déploiement', icon: Package, permission: 'boufi_network', moduleId: 'corner_copilot' },
      { path: '/boufi-ai/boutique', label: 'Boutique Copilot', icon: Store, permission: 'boutique_copilot', moduleId: 'corner_copilot' },
      { path: '/boufi-ai/equipe', label: 'Équipe Corners', icon: Users, permission: 'corner_staff', moduleId: 'corner_copilot' },
      { path: '/boufi-ai/agents', label: 'Mes Agents', icon: Brain, permission: 'corner_view', moduleId: 'corner_copilot' },
      { path: '/boufi-ai/architect', label: 'Architect', icon: Building2, permission: 'corner_staff', moduleId: 'corner_copilot' },
      { path: '/boufi-ai/parametres', label: 'Paramètres IA', icon: Settings, permission: 'corner_staff', moduleId: 'corner_copilot' },
      { path: '/boufi-ai/contrats', label: 'Studio Contrats', icon: FileText, permission: 'corner_staff', moduleId: 'corner_copilot' },
    ],
  },
  {
    title: '🏠 Pilotage',
    items: [
      { path: '/command-center', label: '🎛️ Command Center', icon: Target, permission: 'dashboard', moduleId: 'dashboard' },
      { path: '/dirigeant', label: '📱 Mode Dirigeant', icon: Target, permission: 'dashboard', moduleId: 'dashboard' },
      { path: '/cockpit', label: '☕ Cockpit (matin)', icon: Zap, permission: 'dashboard', moduleId: 'cockpit' },
      { path: '/cerveau', label: 'Cerveau Boufi', icon: Brain, permission: 'rentabilite', moduleId: 'cerveau_boufi' },
      { path: '/dashboard', label: 'Tableau de bord', icon: LayoutDashboard, permission: 'dashboard', moduleId: 'dashboard' },
      { path: '/performance', label: 'Performance du jour', icon: Zap, permission: 'dashboard', moduleId: 'performance' },
      { path: '/kpis-pilotage', label: 'KPIs Pilotage', icon: Target, permission: 'dashboard', moduleId: 'kpis_pilotage' },
      { path: '/rapport-hebdo', label: 'Rapport Hebdo', icon: FileText, permission: 'rentabilite', moduleId: 'rapport_hebdo' },
      { path: '/alert-cockpit', label: 'Cockpit Alertes', icon: Bell, permission: 'rentabilite', moduleId: 'alert_cockpit' },
      { path: '/journal-direction', label: 'Journal Direction', icon: BookOpen, permission: 'rentabilite', moduleId: 'journal_direction' },
      { path: '/calendrier', label: '📅 Calendrier', icon: CalendarDays, permission: 'predictions', moduleId: 'calendrier' },
      { path: '/launches', label: 'LTO Launch Cockpit', icon: Sparkles, permission: 'rentabilite', moduleId: 'launches' },
      { path: '/alertes', label: 'Alertes', icon: Bell, permission: 'alertes', moduleId: 'alertes' },
    ],
  },
  {
    title: '🌮 Chamas Tacos',
    items: [
      { path: '/chamas', label: "Vue d'ensemble", icon: Store, permission: 'rentabilite', moduleId: 'rentabilite' },
      { path: '/chamas/catalogue', label: 'Catalogue', icon: Library, permission: 'rentabilite', moduleId: 'rentabilite' },
      { path: '/chamas/stats', label: 'Statistiques ventes', icon: BarChart3, permission: 'rentabilite', moduleId: 'rentabilite' },
      { path: '/chamas/foodcost', label: 'Food cost', icon: ChefHat, permission: 'rentabilite', moduleId: 'rentabilite' },
      { path: '/chamas/stocks', label: 'Achats & Stocks', icon: Package, permission: 'rentabilite', moduleId: 'rentabilite' },
      { path: '/chamas/resultat', label: 'Résultat (EBITDA)', icon: BarChart3, permission: 'rentabilite', moduleId: 'rentabilite' },
      { path: '/chamas/recettes', label: 'Fiches recettes', icon: ChefHat, permission: 'rentabilite', moduleId: 'rentabilite' },
      { path: '/chamas/nouveautes', label: 'Nouveautés', icon: Sparkles, permission: 'rentabilite', moduleId: 'rentabilite' },
      { path: '/chamas/sync', label: 'Synchronisation Biborne', icon: History, permission: 'rentabilite', moduleId: 'rentabilite' },
    ],
  },
  {
    title: '💰 Finances & Rentabilité',
    items: [
      { path: '/analyse-rentabilite', label: 'Analyse Rentabilité', icon: TrendingUp, permission: 'rentabilite', moduleId: 'rentabilite' },
      { path: '/ventes-ruptures', label: 'Ventes & Ruptures', icon: TrendingUp, permission: 'rentabilite', moduleId: 'rentabilite' },
      { path: '/rapport-tva', label: 'Rapport TVA', icon: Calculator, permission: 'rentabilite', moduleId: 'rentabilite' },
      { path: '/audit-marges', label: 'Audit Marges', icon: ChefHat, permission: 'rentabilite', moduleId: 'audit_marges' },
      { path: '/dashboard-global', label: 'Dashboard Global', icon: BarChart3, permission: 'rentabilite', moduleId: 'dashboard_global' },
      { path: '/multicanal', label: 'Multi-Canal', icon: BarChart3, permission: 'rentabilite', moduleId: 'multicanal' },
      { path: '/gestion-couts', label: 'Gestion Coûts', icon: Wallet, permission: 'rentabilite', moduleId: 'gestion_couts' },
      { path: '/food-cost', label: 'Food Cost', icon: Target, permission: 'rentabilite', moduleId: 'food_cost' },
      { path: '/mercuriale', label: 'Mercuriale', icon: BookOpen, permission: 'rentabilite', moduleId: 'mercuriale' },
      { path: '/simulateur', label: 'Simulateur Prix', icon: Calculator, permission: 'rentabilite', moduleId: 'simulateur' },
      { path: '/calculateur-promo', label: 'Calculateur Promo', icon: Megaphone, permission: 'rentabilite', moduleId: 'simulateur' },
      { path: '/fiches-de-paie', label: 'Fiches de Paie', icon: FileText, permission: 'rentabilite', moduleId: 'fiches_de_paie' },
      { path: '/rapport-franchiseur', label: 'Rapport Franchiseur', icon: Trophy, permission: 'scalabilite', moduleId: 'scalabilite' },
    ],
  },
  {
    title: '🛒 Ventes & Canaux',
    items: [
      { path: '/historique-ventes', label: 'Historique Ventes', icon: History, permission: 'rentabilite', moduleId: 'historique_ventes' },
      { path: '/referentiel-produits', label: 'Référentiel Produits', icon: Library, permission: 'rentabilite', moduleId: 'referentiel_produits' },
      { path: '/cartes', label: 'Cartes Réseau', icon: LayoutGrid, permission: 'rentabilite', moduleId: 'referentiel_produits' },
      { path: '/referentiel-clients', label: 'Référentiel Clients', icon: Users, permission: 'rentabilite', moduleId: 'referentiel_clients' },
      { path: '/ca-corrections', label: 'Correction CA', icon: Edit, permission: 'rentabilite', moduleId: 'ca_corrections' },
      { path: '/ubereats', label: 'Uber Eats Intelligence', icon: ShoppingCart, permission: 'rentabilite', moduleId: 'ubereats' },
      { path: '/uber-eats-import', label: 'Import Uber Eats', icon: Truck, permission: 'rentabilite', moduleId: 'uber_eats_import' },
      { path: '/codes-promo', label: 'Codes Promo', icon: Tag, permission: 'rentabilite', moduleId: 'codes_promo' },
      { path: '/creators-admin', label: '🌟 Boufi Creators', icon: Users, permission: 'rentabilite', moduleId: 'creators_admin' },
      { path: '/produits-db', label: '📦 Base Produits', icon: Package, permission: 'rentabilite', moduleId: 'produits_db' },
    ],
  },
  {
    title: '🔌 Biborne',
    items: [
      { path: '/dashboard-biborne', label: 'Dashboard Biborne', icon: BarChart3, permission: 'rentabilite', moduleId: 'dashboard_biborne' },
      { path: '/biborne-database', label: 'Base Biborne', icon: Database, permission: 'rentabilite', moduleId: 'biborne_database' },
      { path: '/menu-import', label: 'Import Menu Biborne', icon: Cookie, permission: 'rentabilite', moduleId: 'menu_import' },
    ],
  },
  {
    title: '🛍️ WhatsApp Shop',
    items: [
      { path: '/wa-shop', label: 'Shop WhatsApp', icon: ShoppingBag, permission: 'fidelite_admin', moduleId: 'wa_shop' },
      { path: '/cuisine', label: '👨‍🍳 Vue Cuisine', icon: ChefHat, permission: 'fidelite_admin', moduleId: 'cuisine' },
    ],
  },
  {
    title: '🏭 Crust France',
    items: [
      { path: '/crust', label: 'Rétrocessions', icon: BarChart3, permission: 'rentabilite', moduleId: 'crust' },
      { path: '/crust/b2b', label: '🧠 B2B Copilot', icon: BarChart3, permission: 'rentabilite', moduleId: 'crust' },
      { path: '/crust/crm', label: '🗂 Devis & BC', icon: FileText, permission: 'rentabilite', moduleId: 'crust' },
      { path: '/crust/circuits', label: '🔄 Circuits', icon: BarChart3, permission: 'rentabilite', moduleId: 'crust' },
      { path: '/crust/bons-commande', label: '📥 Bons de commande (OCR)', icon: ShoppingBag, permission: 'rentabilite', moduleId: 'crust' },
      { path: '/crust/banque', label: '💳 Banque Qonto', icon: BarChart3, permission: 'rentabilite', moduleId: 'crust' },
      { path: '/crust/workflows', label: '⚙️ Workflows auto', icon: BarChart3, permission: 'rentabilite', moduleId: 'crust' },
      { path: '/crust/validations', label: '🛡️ Validations', icon: BarChart3, permission: 'rentabilite', moduleId: 'crust' },
      { path: '/crust/rapports', label: '📊 Rapports rétrocession', icon: BarChart3, permission: 'rentabilite', moduleId: 'crust' },
      { path: '/crust/rapports/stats', label: '📈 Stats rétrocession', icon: BarChart3, permission: 'rentabilite', moduleId: 'crust' },
      { path: '/crust/factures', label: 'Factures', icon: ShoppingBag, permission: 'rentabilite', moduleId: 'crust' },
      { path: '/crust/factures-recues', label: '📥 Factures reçues', icon: ShoppingBag, permission: 'rentabilite', moduleId: 'crust' },
      { path: '/crust/factures/new', label: '+ Nouvelle facture', icon: ChefHat, permission: 'rentabilite', moduleId: 'crust' },
      { path: '/crust/tarifs', label: 'Tarifs', icon: BarChart3, permission: 'rentabilite', moduleId: 'crust' },
      { path: '/crust/clients', label: 'Clients finaux', icon: ShoppingBag, permission: 'rentabilite', moduleId: 'crust' },
      { path: '/crust/produits', label: 'Produits éligibles', icon: Cookie, permission: 'rentabilite', moduleId: 'crust' },
    ],
  },
  {
    title: '📱 WhatsApp CRM',
    items: [
      { path: '/inbox', label: 'WhatsApp Inbox', icon: MessageCircle, permission: 'fidelite_admin', moduleId: 'whatsapp_inbox' },
      { path: '/whatsapp-manager', label: 'WhatsApp Manager', icon: MessageCircle, permission: 'fidelite_admin', moduleId: 'whatsapp_manager' },
      { path: '/whatsapp-templates', label: 'Templates WhatsApp', icon: MessageCircle, permission: 'fidelite_admin', moduleId: 'whatsapp_templates', adminOnly: true },
      { path: '/whatsapp-brief', label: 'Brief WhatsApp', icon: MessageCircle, permission: 'users_manage', moduleId: 'whatsapp_brief' },
      { path: '/lia-chat', label: 'Lia Chat', icon: Sparkles, permission: 'users_manage', moduleId: 'users_manage' },
      { path: '/lia-console', label: 'Lia Console', icon: MessageSquareText, permission: 'users_manage', moduleId: 'users_manage' },
      { path: '/lia-brain', label: 'Lia Brain (IA)', icon: Brain, permission: 'users_manage', moduleId: 'users_manage' },
      { path: '/knowledge', label: 'Base de Connaissance', icon: Library, permission: 'ai_intelligence', moduleId: 'knowledge' },
    ],
  },
  {
    title: '🤖 IA & Prédictif',
    items: [
      { path: '/ai-intelligence', label: 'IA Prédictive', icon: Brain, permission: 'ai_intelligence', moduleId: 'ai_intelligence' },
      { path: '/predictions', label: 'Prédictions vs Réel', icon: Target, permission: 'predictions', moduleId: 'predictions' },
      { path: '/cross-analysis', label: 'Cross-Analyse', icon: Activity, permission: 'rentabilite', moduleId: 'cross_analysis' },
      { path: '/staffing-optimizer', label: 'Staffing Optimizer', icon: Target, permission: 'rentabilite', moduleId: 'staffing_optimizer' },
      { path: '/bouffi-assistant', label: 'Bouffi Assistant', icon: Brain, permission: 'formations', moduleId: 'bouffi_assistant' },
    ],
  },
  {
    title: '🍪 Production & Stock',
    items: [
      { path: '/production', label: '🔥 Plan de Production', icon: Cookie, permission: 'production_plan', moduleId: 'comptage_cookies' },
      { path: '/comptage', label: 'Comptage Produits', icon: Cookie, permission: 'comptage_cookies', moduleId: 'comptage_cookies' },
      { path: '/boufi-intelligence', label: '🍪 Boufi Intelligence', icon: Activity, permission: 'dashboard', moduleId: 'comptage_cookies' },
      { path: '/analytics-360', label: '📊 Analytics 360', icon: Activity, permission: 'dashboard', moduleId: 'analytics_360' },
      { path: '/galerie-cameras', label: '🎥 Galerie Caméras', icon: Activity, permission: 'galerie_cameras', moduleId: 'galerie_cameras' },
      { path: '/stock-frigo', label: 'Stock Boufi Shop', icon: Cookie, permission: 'stock_frigo', moduleId: 'stock_frigo' },
      { path: '/tracabilite-etiquettes', label: 'Traçabilité Étiquettes', icon: ScanLine, permission: 'audit_hygiene', moduleId: 'tracking_labels' },
    ],
  },
  {
    title: '🖥️ Borne & Ventes',
    items: [
      { path: '/caisse-comptoir', label: '🛒 Caisse Comptoir', icon: Tablet, permission: 'planning', moduleId: 'fidelite' },
      { path: '/mapping-biborne', label: '🔗 Mapping Biborne', icon: Tablet, permission: 'planning', moduleId: 'fidelite' },
      { path: '/borne-caisse', label: '⚙️ Pilotage Borne', icon: GraduationCap, permission: 'planning', moduleId: 'fidelite' },
      { path: '/controle-caisse', label: '🔍 Contrôle Caisse', icon: BarChart3, permission: 'planning', moduleId: 'fidelite' },
      { path: '/shadow', label: '🕶️ Shadow Zéro Rupture', icon: BarChart3, permission: 'planning', moduleId: 'fidelite' },
      { path: '/dashboard-canaux', label: '⚖️ Borne vs Comptoir', icon: BarChart3, permission: 'planning', moduleId: 'fidelite' },
      { path: '/borne-dashboard', label: '📊 Commandes & Stats', icon: BarChart3, permission: 'planning', moduleId: 'fidelite' },
      { path: '/borne', label: '📱 Écran client (tablette)', icon: GraduationCap, permission: 'planning', moduleId: 'fidelite' },
      { path: '/borne-v2?boutique=aix&poste=9', label: '📱 Borne V2 (écran client)', icon: GraduationCap, permission: 'planning', moduleId: 'fidelite' },
      { path: '/borne-ecran', label: '📺 Suivi salle', icon: GraduationCap, permission: 'planning', moduleId: 'fidelite' },
      { path: '/borne-backbar', label: '🥤 Back-bar', icon: GraduationCap, permission: 'planning', moduleId: 'fidelite' },
      { path: '/backbar-v2', label: '🧋 Back Bar V2 · Boissons & Glaces', icon: GraduationCap, permission: 'planning', moduleId: 'fidelite' },
    ],
  },
  {
    title: '❤️ Marketing & Fidélité',
    items: [
      { path: '/fidelite', label: 'Fidélité', icon: Cookie, permission: 'planning', moduleId: 'fidelite' },
      { path: '/drop-caisse', label: '🎓 Caisse Drop', icon: GraduationCap, permission: 'planning', moduleId: 'fidelite' },
      { path: '/mur/bac-to-boufi', label: '🎓 Mur des mentions', icon: GraduationCap, permission: 'planning', moduleId: 'fidelite' },
      { path: '/ai-seller', label: '🧠 AI Seller', icon: Sparkles, permission: 'planning', moduleId: 'fidelite' },
      { path: '/fidelite-admin', label: 'Gestion Fidélité', icon: Crown, permission: 'fidelite_admin', moduleId: 'fidelite_admin' },
      { path: '/formation-fidelite', label: 'Formation Fidélité', icon: GraduationCap, permission: 'fidelite_admin', moduleId: 'formation_fidelite' },
      { path: '/campagnes', label: 'Campagnes & Events', icon: Sparkles, permission: 'predictions', moduleId: 'predictions' },
      { path: '/rapport-campagnes', label: 'Rapport Campagnes', icon: FileText, permission: 'rentabilite', moduleId: 'rapport_campagnes' },
      { path: '/influence-marketing', label: 'Influence Marketing', icon: TrendingUp, permission: 'influence_marketing', moduleId: 'influence_marketing' },
      { path: '/content-studio', label: 'Content Studio', icon: Video, permission: 'rentabilite', moduleId: 'content_studio' },
      { path: '/editions-limitees', label: 'Éditions Limitées', icon: Gem, permission: 'editions_limitees', moduleId: 'editions_limitees' },
      { path: '/moments-admin', label: '🎁 Boufi Moments', icon: Sparkles, permission: 'fidelite_admin', moduleId: 'moments_admin', adminOnly: true },
      { path: '/drop-admin', label: '🎓 Drop Engine', icon: GraduationCap, permission: 'rentabilite', moduleId: 'drop_engine' },
      { path: '/reputation', label: 'Réputation', icon: Star, permission: 'reputation', moduleId: 'reputation' },
    ],
  },
  {
    title: '👥 Équipe',
    items: [
      { path: '/horaires', label: 'Horaires & Planning', icon: Clock, permission: 'rentabilite', moduleId: 'horaires' },
      { path: '/planning', label: 'Planning', icon: CalendarDays, permission: 'planning', moduleId: 'planning' },
      { path: '/hub-equipe', label: '📲 Hub Équipe (WA)', icon: MessageSquareText, permission: 'rentabilite', moduleId: 'hub_equipe' },
      { path: '/messagerie-interne', label: 'Messagerie Interne', icon: MessageSquareText, permission: 'planning', moduleId: 'messagerie_interne' },
      { path: '/academie', label: '🎓 Boufi Académie', icon: GraduationCap, permission: 'formations', moduleId: 'formations' },
      { path: '/formations', label: 'Formations', icon: GraduationCap, permission: 'formations', moduleId: 'formations' },
      { path: '/innovations', label: 'Innovation', icon: Lightbulb, permission: 'innovations', moduleId: 'innovations' },
      { path: '/rapports', label: 'Rapports Journaliers', icon: ClipboardList, permission: 'rapports', moduleId: 'rapports' },
      { path: '/boufi-league', label: 'Boufi League', icon: Trophy, permission: 'boufi_league', moduleId: 'boufi_league', adminOnly: true },
    ],
  },
  {
    title: '🏬 Réseau',
    items: [
      { path: '/carte', label: 'Carte réseau', icon: Map, permission: 'carte', moduleId: 'carte' },
      { path: '/bornes', label: '🖥 Bornes V1/V2', icon: Tv, moduleId: 'bornes', alwaysVisible: true },
      { path: '/borne-v2-studio', label: '🎛 Studio V2', icon: Tv, moduleId: 'bornes', alwaysVisible: true },
      { path: '/boutiques', label: 'Boutiques', icon: Store, permission: 'boutiques', moduleId: 'boutiques' },
      { path: '/inspections', label: 'Inspections', icon: ClipboardCheck, permission: 'inspections', moduleId: 'inspections' },
      { path: '/audit-hygiene', label: 'Audits', icon: ShieldCheck, permission: 'audit_hygiene', moduleId: 'audit_hygiene' },
    ],
  },
  {
    title: '⚙️ Paramètres',
    items: [
      { path: '/reglages', label: 'Réglages Modules', icon: Settings, permission: 'users_manage', moduleId: 'users_manage' },
      { path: '/rgpd', label: 'RGPD & Données', icon: ClipboardList, permission: 'users_manage', moduleId: 'users_manage' },
      { path: '/utilisateurs', label: 'Utilisateurs', icon: Users, permission: 'users_manage', moduleId: 'users_manage' },
      { path: '/settings/boutiques', label: 'Paramètres Boutiques', icon: Store, permission: 'users_manage', moduleId: 'users_manage' },
      { path: '/settings/api-keys', label: 'Clés API', icon: ShieldCheck, permission: 'users_manage', moduleId: 'users_manage' },
      { path: '/settings/connexions-ia', label: '🤖 Connexions IA (ChatGPT)', icon: ShieldCheck, permission: 'users_manage', moduleId: 'users_manage' },
      { path: '/settings/actions-ia', label: '⚡ Actions IA', icon: ShieldCheck, permission: 'users_manage', moduleId: 'users_manage' },
      { path: '/settings/couts-ia', label: 'Coûts IA', icon: Coins, permission: 'users_manage', moduleId: 'users_manage' },
      { path: '/settings/roles', label: 'Rôles & Permissions', icon: ShieldCheck, permission: 'users_manage', moduleId: 'users_manage' },
      { path: '/settings/agents-control', label: 'Contrôle des Agents', icon: Sparkles, permission: 'users_manage', moduleId: 'users_manage' },
      { path: '/backups', label: '🗄️ Sauvegardes', icon: Database, permission: 'users_manage', moduleId: 'users_manage' },
      { path: '/schedulers', label: 'Schedulers', icon: Clock, permission: 'users_manage', moduleId: 'schedulers' },
      { path: '/guide', label: 'Guide', icon: FileText, permission: 'guide', moduleId: 'guide' },
    ],
  },
];

const ROLE_CONFIG = {
  admin: { label: 'Direction', dot: '#FF5C00' },
  inspecteur: { label: 'Inspecteur', dot: '#3B82F6' },
  licencie: { label: 'Licencié', dot: '#10B981' },
  manager: { label: 'Manager', dot: '#EAB308' },
  associe: { label: 'Associé', dot: '#A855F7' },
};

const SIDEBAR_COLLAPSED_KEY = 'boufi_sidebar_collapsed';

// ============== BOUTIQUE SELECTOR ==============
const BoutiqueSelector = ({ boutiques, selectedId, onSelect, collapsed }) => {
  if (!boutiques || boutiques.length === 0) return null;
  if (collapsed) return null;
  if (boutiques.length === 1) {
    return (
      <div className="mx-3 mb-3 px-3 py-2.5 rounded-2xl bg-surface-muted">
        <p className="text-[10px] uppercase tracking-wider text-ink-3 mb-0.5 font-semibold">Ma boutique</p>
        <p className="text-sm font-semibold text-ink-1 flex items-center gap-2">
          <Store className="w-3.5 h-3.5 text-[#FF5C00]" />
          {boutiques[0].name}
        </p>
      </div>
    );
  }
  return (
    <div className="mx-3 mb-3">
      <p className="text-[10px] uppercase tracking-wider text-ink-3 mb-1 font-semibold px-1">Mes boutiques</p>
      <Select value={selectedId} onValueChange={onSelect}>
        <SelectTrigger className="w-full rounded-2xl border-hairline bg-surface-muted text-sm h-10">
          <SelectValue placeholder="Sélectionner" />
        </SelectTrigger>
        <SelectContent>
          {boutiques.map((b) => (
            <SelectItem key={b.id} value={b.id}>
              <div className="flex items-center gap-2">
                <Store className="w-4 h-4" />
                {b.name}
              </div>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

// ============== SIDEBAR ==============
const Sidebar = ({ onNavigate, collapsed, onToggleCollapse }) => {
  const location = useLocation();
  const { user, logout, hasPermission, isLicencie, isManager, selectedBoutiqueId, setSelectedBoutiqueId, userBoutiquesIds } = useAuth();
  const navigate = useNavigate();
  const [boutiques, setBoutiques] = useState([]);
  const [search, setSearch] = useState('');
  const [openGroups, setOpenGroups] = useState(() => {
    try {
      const saved = JSON.parse(localStorage.getItem('boufi_nav_open_v2') || 'null');
      if (saved && typeof saved === 'object') return saved;
    } catch { /* fall through */ }
    // Defaut : seul Pilotage est ouvert au 1er chargement
    return { '🏠 Pilotage': true };
  });

  useEffect(() => {
    localStorage.setItem('boufi_nav_open_v2', JSON.stringify(openGroups));
  }, [openGroups]);

  useEffect(() => {
    api.get('/boutiques').then(r => {
      const list = r.data || [];
      setBoutiques(list);
      if (list.length && (!selectedBoutiqueId || !list.some((b) => b.id === selectedBoutiqueId))) {
        setSelectedBoutiqueId(list[0].id);
      }
    }).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const hasCustomPerms = Array.isArray(user?.custom_permissions) && user.custom_permissions.length > 0;
  const [execOk, setExecOk] = useState(sessionStorage.getItem('exec_ok') === '1');
  useEffect(() => {
    api.get('/exec/acces').then((r) => {
      const ok = !!r.data?.ok;
      setExecOk(ok);
      sessionStorage.setItem('exec_ok', ok ? '1' : '0');
    }).catch(() => setExecOk(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const canSeeItem = (item) => {
    if (item.alwaysVisible) return true;
    if (item.permission === 'galerie_cameras') return hasPermission('galerie_cameras');
    if (item.public) return !hasCustomPerms || user.custom_permissions.includes(item.moduleId || item.permission);
    if (item.adminOnly && !['admin', 'direction'].includes(user.role)) return false;
    if (hasCustomPerms) return user.custom_permissions.includes(item.moduleId || item.permission);
    return hasPermission(item.permission);
  };

  const filteredSections = useMemo(() => {
    const q = search.trim().toLowerCase();
    const base = execOk
      ? [{ title: '🎓 Privé', items: [{ path: '/executive-coach', label: 'Executive Coach', icon: GraduationCap, public: true, moduleId: 'executive_coach' }] }, ...navSections]
      : navSections;
    return base
      .map(s => ({
        ...s,
        items: s.items.filter(it => (it.moduleId === 'executive_coach' ? true : canSeeItem(it)) && (!q || it.label.toLowerCase().includes(q))),
      }))
      .filter(s => s.items.length > 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, user, execOk]);

  // Auto-open the section containing the active route
  useEffect(() => {
    const activeSection = navSections.find(s => s.items.some(i => i.path === location.pathname));
    if (activeSection?.title && !openGroups[activeSection.title]) {
      setOpenGroups((g) => ({ ...g, [activeSection.title]: true }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  const handleLogout = () => { logout(); navigate('/login'); };
  const roleConfig = ROLE_CONFIG[user?.role] || { label: user?.role, dot: '#9CA3AF' };
  const isSearching = search.trim().length > 0;

  return (
    <div className="h-full flex flex-col bg-surface-elev border-r border-hairline bshell-side">
      {/* ===== Brand ===== */}
      <div className={`px-4 ${collapsed ? 'py-4' : 'py-5'} flex items-center ${collapsed ? 'justify-center' : 'justify-between'} border-b border-hairline`}>
        {!collapsed ? (
          <>
            <Link to="/dashboard" className="flex items-center gap-2.5 min-w-0" onClick={onNavigate}>
              <div className="w-9 h-9 rounded-2xl bg-[#FF5C00] flex items-center justify-center ring-inner-soft glow-brand shrink-0">
                <Cookie className="w-5 h-5 text-white" strokeWidth={2.2} />
              </div>
              <div className="min-w-0">
                <div className="font-display text-[15px] font-extrabold text-ink-1 leading-tight tracking-tight">Boufi OS</div>
                <div className="text-[10px] text-ink-3 leading-tight">Cookie Network</div>
              </div>
            </Link>
            {onToggleCollapse && (
              <button
                onClick={onToggleCollapse}
                className="hidden md:flex p-1.5 rounded-lg hover:bg-surface-muted text-ink-3 transition"
                data-testid="sidebar-collapse-btn"
                title="Réduire"
              >
                <ChevronLeft className="w-4 h-4" />
              </button>
            )}
          </>
        ) : (
          <Link to="/dashboard" className="flex items-center justify-center" onClick={onNavigate}>
            <div className="w-9 h-9 rounded-2xl bg-[#FF5C00] flex items-center justify-center ring-inner-soft glow-brand">
              <Cookie className="w-5 h-5 text-white" strokeWidth={2.2} />
            </div>
          </Link>
        )}
      </div>

      {/* ===== Search ===== */}
      {!collapsed && (
        <div className="px-3 pt-3 pb-2">
          <div className="relative">
            <Search className="w-3.5 h-3.5 absolute left-3 top-1/2 -translate-y-1/2 text-ink-3" />
            <input
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Rechercher un module…"
              className="w-full pl-8 pr-3 py-2 rounded-xl bg-surface-muted border border-transparent focus:border-hairline focus:bg-surface-elev text-sm text-ink-1 placeholder:text-ink-3 outline-none transition"
              data-testid="sidebar-search"
            />
          </div>
        </div>
      )}

      {/* ===== Boutique selector ===== */}
      {boutiques.length > 0 && (
        <BoutiqueSelector
          boutiques={(isLicencie || isManager) && userBoutiquesIds.length ? boutiques.filter((b) => userBoutiquesIds.includes(b.id)) : boutiques}
          selectedId={selectedBoutiqueId}
          onSelect={setSelectedBoutiqueId}
          collapsed={collapsed}
        />
      )}

      {/* ===== Nav sections ===== */}
      <nav className={`flex-1 overflow-y-auto ${collapsed ? 'px-2 py-2' : 'px-3 py-2'} space-y-1`}>
        {filteredSections.map((section, sIdx) => {
          // Section ouverte SI : recherche active OU explicitement ouverte
          const open = isSearching || openGroups[section.title] === true;
          return (
            <div key={section.title || sIdx} className="anim-fade">
              {!collapsed && section.title && (
                <button
                  type="button"
                  onClick={() => setOpenGroups((g) => ({ ...g, [section.title]: !open }))}
                  className={`w-full flex items-center justify-between px-3 py-2 mt-1 rounded-xl text-[12px] font-semibold transition ${
                    open
                      ? 'bg-surface-muted text-ink-1'
                      : 'text-ink-2 hover:bg-surface-muted hover:text-ink-1'
                  }`}
                  data-testid={`nav-group-${section.title}`}
                >
                  <span className="flex items-center gap-1.5">
                    {section.title}
                    {!open && (
                      <span className="text-[10px] font-medium text-ink-3 ml-1">
                        ({section.items.length})
                      </span>
                    )}
                  </span>
                  {!isSearching && (
                    <ChevronDown className={`w-3.5 h-3.5 transition-transform ${open ? '' : '-rotate-90'}`} />
                  )}
                </button>
              )}
              {(open || collapsed) && (
                <div className="space-y-0.5 mb-1">
                  {section.items.map((item) => {
                    const Icon = item.icon;
                    const isActive = location.pathname === item.path;
                    return (
                      <Link
                        key={item.path}
                        to={item.path}
                        onClick={onNavigate}
                        data-testid={`nav-${item.path.slice(1)}`}
                        title={collapsed ? item.label : undefined}
                        className={`
                          group relative flex items-center gap-3 ${collapsed ? 'justify-center px-2' : 'px-3'} py-2 rounded-xl text-[13px] font-medium transition-all
                          ${isActive
                            ? 'bnav-active'
                            : 'text-ink-2 hover:bg-surface-muted hover:text-ink-1'
                          }
                        `}
                      >
                        <Icon className="w-4 h-4 shrink-0" strokeWidth={1.8} />
                        {!collapsed && (
                          <>
                            <span className="truncate flex-1">{item.label}</span>
                            {isActive && <ChevronRight className="w-3 h-3" />}
                          </>
                        )}
                      </Link>
                    );
                  })}
                </div>
              )}
            </div>
          );
        })}
        {isSearching && filteredSections.length === 0 && (
          <div className="text-xs text-ink-3 px-3 py-6 text-center">Aucun module trouvé</div>
        )}
      </nav>

      {/* ===== User footer ===== */}
      <div className="border-t border-hairline p-3 mt-auto">
        {!collapsed ? (
          <>
            <div className="flex items-center gap-3 px-2 py-2 rounded-2xl bg-surface-muted mb-2">
              <div className="relative w-9 h-9 rounded-full bg-surface-elev border border-hairline flex items-center justify-center shrink-0">
                <User className="w-4 h-4 text-ink-2" />
                <span className="absolute -bottom-0.5 -right-0.5 w-2.5 h-2.5 rounded-full border-2 border-surface-muted" style={{ backgroundColor: roleConfig.dot }} />
              </div>
              <div className="min-w-0 flex-1">
                <div className="text-sm font-semibold text-ink-1 truncate">{user?.name}</div>
                <div className="text-[10px] text-ink-3 uppercase tracking-wider font-semibold">{roleConfig.label}</div>
                <CertifBadge />
              </div>
            </div>

            {isLicencie && userBoutiquesIds?.length > 1 && (
              <div className="px-3 mb-2 text-[10px] text-ink-3 flex items-center gap-1">
                <Building2 className="w-3 h-3" />
                {userBoutiquesIds.length} boutiques gérées
              </div>
            )}

            {(isManager || user?.role === 'admin') && (
              <button
                className="w-full flex items-center gap-2 px-3 py-2 rounded-xl text-[13px] font-medium text-ink-2 hover:bg-surface-muted hover:text-ink-1 transition"
                onClick={() => window.open('/kiosk', '_blank')}
                data-testid="install-kiosk-btn"
              >
                <Tablet className="w-4 h-4" strokeWidth={1.8} /> Installer Kiosque
              </button>
            )}
            <div className="flex items-center justify-between px-3 py-1 md:hidden">
              <span className="text-[13px] font-medium text-ink-2">Thème</span>
              <ThemeToggle testId="theme-toggle-mobile" />
            </div>
            <button
              className="w-full flex items-center gap-2 px-3 py-2 rounded-xl text-[13px] font-medium text-ink-2 hover:bg-red-500/10 hover:text-red-500 transition"
              onClick={handleLogout}
              data-testid="logout-btn"
            >
              <LogOut className="w-4 h-4" strokeWidth={1.8} /> Déconnexion
            </button>
          </>
        ) : (
          <div className="flex flex-col items-center gap-1">
            <button
              onClick={onToggleCollapse}
              className="w-full flex justify-center p-2 rounded-xl hover:bg-surface-muted text-ink-3 transition"
              data-testid="sidebar-expand-btn"
              title="Étendre"
            >
              <ChevronRight className="w-4 h-4" />
            </button>
            <button
              className="w-full flex justify-center p-2 rounded-xl hover:bg-red-500/10 hover:text-red-500 text-ink-2 transition"
              onClick={handleLogout}
              data-testid="logout-btn"
              title="Déconnexion"
            >
              <LogOut className="w-4 h-4" strokeWidth={1.8} />
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

// ============== THEME TOGGLE ==============
const ThemeToggle = ({ testId = 'theme-toggle' }) => {
  const { theme, toggle } = useTheme();
  const isDark = theme === 'dark';
  return (
    <button
      onClick={toggle}
      className="relative w-9 h-9 rounded-full bg-surface-muted hover:bg-surface-elev border border-hairline flex items-center justify-center text-ink-2 hover:text-ink-1 transition"
      data-testid={testId}
      aria-label={isDark ? 'Mode clair' : 'Mode sombre'}
      title={isDark ? 'Mode clair' : 'Mode sombre'}
    >
      {isDark ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
    </button>
  );
};

// ============== MOBILE BOTTOM NAV ==============
const MobileNav = () => {
  const location = useLocation();
  const { user, hasPermission } = useAuth();

  const hasCustomPerms = Array.isArray(user?.custom_permissions) && user.custom_permissions.length > 0;
  const allItems = navSections.flatMap(s => s.items);
  const canSee = (perm, moduleId) => {
    if (hasCustomPerms) return user.custom_permissions.includes(moduleId || perm);
    return hasPermission(perm);
  };
  const spec = [
    { path: '/aujourdhui', label: "Aujourd'hui", permission: 'corner_view' },
    { path: '/boufi-ai', label: 'Projets', permission: 'corner_view' },
    { path: '/stock-frigo', label: 'Stock' },
    { path: '/inbox', label: 'Messages' },
  ];
  const items = spec.map((s) => {
    const found = allItems.find((it) => it.path === s.path);
    return { ...s, icon: found?.icon || LayoutDashboard, permission: s.permission || found?.permission, moduleId: found?.moduleId };
  }).filter((it) => canSee(it.permission, it.moduleId));

  return (
    <nav className="sticky bottom-0 left-0 right-0 md:hidden z-40 pb-safe shrink-0 bg-surface-elev border-t border-hairline">
      <div className={`grid grid-cols-${items.length || 1} px-2 pt-1.5 pb-1.5`} style={{ gridTemplateColumns: `repeat(${items.length || 1}, 1fr)` }}>
        {items.map((item) => {
          const Icon = item.icon;
          const isActive = item.path === '/boufi-ai' ? location.pathname.startsWith('/boufi-ai') : location.pathname === item.path;
          return (
            <Link
              key={item.path}
              to={item.path}
              data-testid={`mobile-nav-${item.path.slice(1)}`}
              className={`flex flex-col items-center gap-0.5 py-1.5 ${isActive ? '' : 'text-ink-3'}`}
              style={{ minHeight: 44, color: isActive ? '#E8621C' : undefined }}
            >
              <Icon className="w-5 h-5" strokeWidth={isActive ? 2.2 : 1.7} />
              <span className="text-[10px] font-semibold">{item.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

// ============== LAYOUT ==============
const CertifBadge = () => {
  const [ok, setOk] = useState(false);
  useEffect(() => { api.get('/academie/mes-resultats').then((r) => setOk(!!r.data.certifie)).catch(() => {}); }, []);
  if (!ok) return null;
  return <div data-testid="profil-badge-certifie" className="text-[10px] font-bold mt-0.5" style={{ color: '#C97B2D' }}>🎓 Caissier certifié</div>;
};

export const Layout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(() => {
    try { return localStorage.getItem(SIDEBAR_COLLAPSED_KEY) === '1'; }
    catch { return false; }
  });

  useEffect(() => {
    localStorage.setItem(SIDEBAR_COLLAPSED_KEY, collapsed ? '1' : '0');
  }, [collapsed]);

  useInboxNotifications({ enabled: true });

  const sidebarWidth = collapsed ? 'md:w-[72px]' : 'md:w-[260px]';
  const mainOffset = collapsed ? 'md:ml-[72px]' : 'md:ml-[260px]';

  return (
    <div className="bshell h-[100dvh] bg-surface flex flex-col md:block md:h-auto md:min-h-screen">
      {/* Halos boutique */}
      <div className="bq-blobs" aria-hidden="true"><i className="a" /><i className="b" /><i className="c" /></div>
      {/* Desktop Sidebar */}
      <aside className={`fixed left-0 top-0 bottom-0 ${sidebarWidth} hidden md:block z-40 transition-[width] duration-200`}>
        <Sidebar collapsed={collapsed} onToggleCollapse={() => setCollapsed((c) => !c)} />
      </aside>

      {/* Mobile Header (glass) */}
      <header
        className="sticky top-0 left-0 right-0 md:hidden z-40 flex items-center px-3 shrink-0 bg-surface-elev/80 backdrop-blur-xl border-b border-hairline pt-safe"
        style={{ minHeight: 'calc(52px + env(safe-area-inset-top, 0px))' }}
      >
        <Sheet open={sidebarOpen} onOpenChange={setSidebarOpen}>
          <SheetTrigger asChild>
            <Button variant="ghost" size="icon" data-testid="mobile-menu-btn" className="text-ink-1">
              <Menu className="w-5 h-5" />
            </Button>
          </SheetTrigger>
          <SheetContent side="left" className="p-0 w-[280px] bg-surface-elev border-r border-hairline">
            <Sidebar onNavigate={() => setSidebarOpen(false)} collapsed={false} />
          </SheetContent>
        </Sheet>

        <Link to="/dashboard" className="flex-1 flex justify-center items-center gap-2">
          <div className="w-7 h-7 rounded-xl bg-[#FF5C00] flex items-center justify-center">
            <Cookie className="w-4 h-4 text-white" strokeWidth={2.2} />
          </div>
          <span className="font-display font-extrabold text-ink-1 tracking-tight">Boufi OS</span>
        </Link>

        <div className="flex items-center gap-1">
          <NotificationBell />
        </div>
      </header>

      {/* Desktop Topbar — slim, contains theme toggle + notifs */}
      <div className={`hidden md:flex ${mainOffset} sticky top-0 z-30 h-14 items-center justify-end gap-2 px-6 bq-topbar bg-surface/80 backdrop-blur-xl border-b border-hairline transition-[margin] duration-200`}>
        <ThemeToggle />
        <NotificationBell />
      </div>

      {/* Main Content */}
      <main className={`${mainOffset} flex-1 overflow-y-auto min-h-0 md:min-h-[calc(100vh-56px)] transition-[margin] duration-200`}>
        <div className="p-4 md:p-8">
          <CrustSubNav />
          {children}
        </div>
      </main>

      {/* Mobile Bottom Nav */}
      <MobileNav />

      {/* PWA install prompt */}
      <InstallPWAPrompt />

      {/* Bulle agent personnel (LIA scopée) */}
      <AgentBubble />
    </div>
  );
};
